import { RiveNavIcon } from "./RiveNavIcon";

export const Home = () => {
    return <RiveNavIcon artboard="Fire" inputName="fire" />;
}

export const HomeFilled = () => {
    return <RiveNavIcon artboard="Fire" inputName="fire" active />;
}
